import { axiosInstance } from "../../../utils";
import _ from "lodash";

const actions = {
  CREATE_OR_UPDATE_CLASSIFICATION_REQUESTED:
    "CREATE_OR_UPDATE_CLASSIFICATION_REQUESTED",
  CREATE_OR_UPDATE_CLASSIFICATION_SUCCEEDED:
    "CREATE_OR_UPDATE_CLASSIFICATION_SUCCEEDED",
  CREATE_OR_UPDATE_CLASSIFICATION_FAILED:
    "CREATE_OR_UPDATE_CLASSIFICATION_FAILED",

  addOrUpdateClassification: (data = undefined) => {
    return {
      type: actions.CREATE_OR_UPDATE_CLASSIFICATION_REQUESTED,
      payload: data,
    };
  },

  createOrUpdateClassification: async (data = undefined) => {
    let url = `classifications/create`;
    let bodyFormData = new FormData();

    if (data.name) bodyFormData.set("name", data.name);
    bodyFormData.set("allow_coupon", !!data.allow_coupon);
    if (data.percentage) bodyFormData.set("percentage", data.percentage);
    if (data._id) {
      url = `classifications/` + data._id;
      try {
        const classification = await axiosInstance.put(url, bodyFormData);
        return classification.data;
      } catch (error) {
        throw error;
      }
    } else {
      if (data.fields) bodyFormData.set("fields", JSON.stringify(data.fields));
      try {
        const classification = await axiosInstance.post(url, bodyFormData);

        return classification.data;
      } catch (error) {
        console.warn(error, "===ss");
        throw error;
      }
    }
  },
};

export default actions;
